import * as Yup from 'yup';
import { i18n } from '../../../../../i18n/index.js';

var getStringValidators = function getStringValidators(_ref) {
  var validators = _ref.validators,
      required = _ref.required,
      type = _ref.type;
  var initialSchema = type === 'email' ? Yup.string().email() : Yup.string();

  if (!validators) {
    return initialSchema;
  }

  var schema = validators.reduce(function (schema, _ref2) {
    var name = _ref2.name,
        value = _ref2.value,
        customErrorMessage = _ref2.customErrorMessage;

    switch (name) {
      case 'minLength':
        if (typeof value !== 'number') {
          break;
        }

        schema = schema.min(value, customErrorMessage || i18n.t('This field should be more than {{value}} characters', {
          value: value
        }));
        break;

      case 'maxLength':
        if (typeof value !== 'number') {
          break;
        }

        schema = schema.max(value, customErrorMessage || i18n.t('This field should be less than {{value}} characters', {
          value: value
        }));
        break;

      case 'regex':
        if (typeof value !== 'string') {
          break;
        }

        schema = schema.matches(new RegExp(value), customErrorMessage || i18n.t('This field should match the regex {{value}}', {
          value: value
        }));
        break;

      case 'isNumber':
        if (typeof value !== 'boolean') {
          break;
        }

        schema = schema.test('isNumber', 'Must be a number', function (value) {
          return !isNaN(value);
        }).typeError(customErrorMessage || i18n.t('This field must be a number'));
        break;

      case 'isEmail':
        if (typeof value !== 'boolean') {
          break;
        }

        schema = schema.email();
        break;
    }

    return schema;
  }, initialSchema);
  return required ? schema.required(i18n.t('This field is required')) : schema;
};

export { getStringValidators };